var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRadar(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 122,
    height: 182,
    viewBox: "0 0 122 182",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    x1: "50%",
    x2: "50%",
    y1: "0%",
    y2: "97.734%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#272727"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "8.94%",
    stopColor: "#BABABA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#D8D8D8",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "b",
    x1: "18.103%",
    x2: "80.736%",
    y1: "3.502%",
    y2: "96.133%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#222"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#4E4E4E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "c",
    x1: "6.118%",
    x2: "89.032%",
    y1: "38.816%",
    y2: "58.23%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#757575"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#5B5B5B"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "d",
    cx: "37.812%",
    cy: "36.614%",
    r: "100%",
    fx: "37.812%",
    fy: "36.614%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#686868"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%"
  })), /*#__PURE__*/React.createElement("circle", {
    id: "e",
    cx: 109.5,
    cy: 13.5,
    r: 2.5
  }), /*#__PURE__*/React.createElement("filter", {
    id: "f",
    width: "180%",
    height: "180%",
    x: "-40%",
    y: "-40%",
    filterUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "SourceAlpha",
    result: "shadowBlurInner1",
    stdDeviation: 1.5
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1,
    in: "shadowBlurInner1",
    result: "shadowOffsetInner1"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "shadowOffsetInner1",
    in2: "SourceAlpha",
    k2: -1,
    k3: 1,
    operator: "arithmetic",
    result: "shadowInnerInner1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "shadowInnerInner1",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.5 0"
  })), /*#__PURE__*/React.createElement("circle", {
    id: "g",
    cx: 95.5,
    cy: 13.5,
    r: 2.5
  }), /*#__PURE__*/React.createElement("filter", {
    id: "h",
    width: "180%",
    height: "180%",
    x: "-40%",
    y: "-40%",
    filterUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "SourceAlpha",
    result: "shadowBlurInner1",
    stdDeviation: 1.5
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1,
    in: "shadowBlurInner1",
    result: "shadowOffsetInner1"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "shadowOffsetInner1",
    in2: "SourceAlpha",
    k2: -1,
    k3: 1,
    operator: "arithmetic",
    result: "shadowInnerInner1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "shadowInnerInner1",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.5 0"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#a)",
    d: "M56 119h11v65H56z"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 121,
    height: 121,
    x: 0.5,
    y: 0.5,
    fill: "url(#b)",
    stroke: "#575757",
    rx: 5
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#FFF",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13 106.64h1.698v3.147h.656v-3.147h1.7v-.602H13zM21.528 106.038H18.74v3.75h.658v-1.399h2.116c.386 0 .568.051.568.516v.882h.628v-1.01a.686.686 0 0 0-.324-.653c.2-.092.366-.284.366-.69v-.289c0-.718-.194-1.107-1.224-1.107zm.568 1.34c0 .26-.102.41-.618.41h-2.08v-1.148h1.968c.698 0 .73.143.73.421v.318zM26.404 106.038l-2.114 3.75h.748l.418-.748h2.578l.416.747h.75l-2.114-3.75h-.682zm-.6 2.4l.95-1.695.952 1.695h-1.902zM41.06 106.17l-.124-.132h-.814l-2.108 1.499h-.44v-1.5h-.656v3.75h.656v-1.646h.404l2.306 1.646h.87l.126-.132-2.604-1.81zM45.636 108.924l-1.91-2.886h-.862v3.75h.656v-2.89l1.902 2.89h.43l1.902-2.89v2.89h.656v-3.75h-.862zM52.128 106.038l-2.114 3.75h.748l.418-.748h2.576l.418.747h.75l-2.114-3.75h-.682zm-.612 2.4l.952-1.695.952 1.695h-1.904zM60.28 106.038v2.966l-2.936-2.966h-.818v3.75h.656v-2.965l2.936 2.964h.818v-3.75zM34.366 108.714c0 .39-.094.51-.688.51h-1.6c-.488 0-.688-.188-.688-.647v-1.329c0-.459.2-.646.688-.646h1.588c.456 0 .67.053.67.524v.268h.6v-.409c0-.45-.2-.985-1.154-.985h-1.74c-.91 0-1.298.421-1.298 1.43v.966c0 1.017.376 1.43 1.298 1.43h1.718c1.03 0 1.236-.422 1.236-1.093v-.346h-.63v.327z"
  })), /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 10,
    x: 90.5,
    y: 8.5,
    fill: "url(#c)",
    stroke: "#393939",
    rx: 5
  }), /*#__PURE__*/React.createElement("use", {
    fill: "url(#d)",
    xlinkHref: "#e"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "#000",
    filter: "url(#f)",
    xlinkHref: "#e"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 109.5,
    cy: 13.5,
    r: 1.5,
    fill: "url(#d)"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "url(#d)",
    xlinkHref: "#g"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "#000",
    filter: "url(#h)",
    xlinkHref: "#g"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 95.5,
    cy: 13.5,
    r: 1.5,
    fill: "url(#d)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRadar);
export default __webpack_public_path__ + "static/media/radar.baef3aba288a15d67ccf5039f0b09aa3.svg";
export { ForwardRef as ReactComponent };